import React, { useContext } from 'react';

export const StudioContext = React.createContext();

export const useStudio = () => useContext(StudioContext);

export const StudioModal = {
	TERMINATE: 'TERMINATE',
};
